
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import type { RecommendItem } from '@xt/client/entities/activitys/types.d.ts'
import { MixinsHomeClick } from '@xt/client/mixins/home'
import type { ClickEvent } from '@xt/client/types/home'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class Recommend extends Mixins(MixinsHomeClick) {
  @Prop({ required: true }) dataSource!: Array<RecommendItem>

  toCourse(item: { cover: string; tip: string; event?: ClickEvent }) {
    if (item.event) {
      this.onClickEvent(item.event)
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
